import { CountryWithStateOutput } from './country-with-state-output.model';


export class CountrySelectByIdOutput implements ICountrySelectByIdOutput {
    status!: number;
    message!: string;
    data!: CountryWithStateOutput;

    constructor(data?: ICountrySelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CountryWithStateOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountrySelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICountrySelectByIdOutput {
    status: number;
    message: string;
    data: CountryWithStateOutput;
}

